import { render } from "./DIcon.vue?vue&type=template&id=c756e4a8&scoped=true"
import script from "./DIcon.vue?vue&type=script&lang=js"
export * from "./DIcon.vue?vue&type=script&lang=js"

import "./DIcon.vue?vue&type=style&index=0&id=c756e4a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c756e4a8"]])

export default __exports__